<script>
  // Vuex
  import { mapGetters } from 'vuex'
  import { paylessMethods } from '@state/helpers'
  import {
    BIcon,
    BIconExclamationCircleFill
  } from 'bootstrap-vue'
  import Multiselect from 'vue-multiselect'
  import ThirdpartyPaylessModal from '@components/euro_pos/ThirdpartyPaylessModal.vue'
  
  export default {
    components: {
      Multiselect,
      BIcon,
      BIconExclamationCircleFill,
      ThirdpartyPaylessModal
    },
    data() {
      return {
        showAlert: null,
        loading: false,
        qr:'',
        correct_qr:true,
        message_qr:'',
        showThirdpartyPaylessModal: false,
        toShow:{}
      }
    },
    mounted() {
  
    },
  
    watch: {
      "qr": function(val){
        if(val.length >= 6)this.orderDetail();
      },
      "showThirdpartyPaylessModal": function(val){
        if(!val){
          this.setFocus();
          this.qr='';
        }
      },
    },
  
    computed: {
      ...mapGetters({
        stores: 'captacionPos/stores',
        store: 'captacionPos/store',
        cashRegister: 'captacionPos/cashRegister',
        casherRegister: 'captacionPos/casherRegister',
      }),
    },
  
    methods: {
      ...paylessMethods,
      
      orderDetail() {
        let context = this
        context.loading=true
        
        let ctx = {
          'qr': context.qr,
          'store_code': context.store.store_code
        }
        console.log(ctx)
        return context.paylessOrderDetail(ctx)
          .then((response) => {
              if(response.error){
                let messageError=response.error.message.split(" ")[0];
                context.toShow.error=true;
                context.toShow.messageError=response.error.message;
                if(messageError=='Payment'){
                  context.toShow.messageError='El código ha expirado';
                }
                if(messageError=='Order'){
                  context.toShow.messageError='El código no corresponde a ninguna orden o ha vencido. Solicite a el RT que confirme o genere uno nuevo';
                }
              } else{
                //console.log(response)
                //if(response.store_euro.code==context.store.store_code){
                  context.toShow.order=response;
                  context.toShow.order.basket.forEach(element => {
                    element.taxes=[{"tax_code":"ANY_IVA","tax_amount":0}]
                  });
                  context.toShow.order.barcode=context.qr
                  context.toShow.order.cashRegister=context.cashRegister.id
                  context.toShow.order.casherRegister=context.casherRegister.codcaj
                  context.toShow.order.store=context.store.store_code
                  context.toShow.amount_payless=response.amount
                  response.amount=0
                /*}else{
                  context.toShow.error=true;
                  context.toShow.messageError='Esta orden pertenece a la tienda '+ response.store_euro.name +', informarle al rappi tendero que se dirija a la tienda correspondiente';
                }*/
              }
              this.showThirdpartyPaylessModal=true;
              context.loading=false
          })
          .catch((error) => {
            console.log('error:',error)
            context.loading=false
          })
      },
      setFocus(){
        setTimeout(() => {
              this.$refs['code-input'].focus()
            }, 200)
      },
    },
  }
  </script>
  
  <template>
    <b-container style="width:100%; height:100%; margin-top: 20%;">
      <b-modal v-model="loading"
        ref="couponModal"
        :title="`${$t('detail_of')} ${$t('thirdparty')}`"
        size="lg"
        class="bg-transparent"
        centered
        :hide-header="true"
        :hide-footer="true"
        :no-close-on-esc="false"
        ok-only
        content-class="bg-transparent">
        <b-container class="p-0 bg-transparent">
          <b-row>
            <b-col md="12">
              <div class="text-center">
                <b-spinner
                  label="Spinning"
                  style="color: #195db2; width: 4rem; height: 4rem"
                ></b-spinner>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
      <div style="width:100%; height:100%" class="d-flex align-items-center justify-content-center flex-column">
        <div style="width:100%" class="card shadow mt-2"> 
          <div class="card-body p-3 pb-0 pt-2" >
            <b-form id="forms_habeas" @submit.prevent="enviarForm">
              <b-row class="justify-content-center">
                <b-col cols="9">
                  <b-form-group
                    id="input-group-1"
                    :label="'Código'"
                    label-class="typo__label"
                    label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="qr"
                      ref="code-input"
                      type="number"
                      required
                      placeholder="Ingrese el código"
                      class="border border-primary"
                      autocomplete="off"
                      autofocus
                    ></b-form-input>
                    <span v-if="!correct_qr" style="color: red">
                      {{ message_qr }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col style="align-self: center;">
                  <b-button style="font-size: 1.15rem;" variant="outline-primary rounded-lg  mx-1"
                          class="ml-1 rounded shadow-sm"
                          @click="orderDetail">
                          <i class="fas fa-check"></i>
                  </b-button>
                  <b-button style="font-size: 1.15rem;"  variant="outline-primary rounded-lg  mx-1"
                          class="ml-1 rounded shadow-sm"
                          @click="qr='', setFocus()">
                          <i class="fas fa-trash"></i>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
          <ThirdpartyPaylessModal
            v-if="showThirdpartyPaylessModal"
            :instanceJson="toShow || {}"
            :oncomplete="
              () => {
                showThirdpartyPaylessModal = false;
                toShow = {};
              }
            "
            :oncancel="
              () => {
                showThirdpartyPaylessModal = false;
                toShow = {}
              }
            "
          >
        </ThirdpartyPaylessModal>
        </div>
      </div>
    </b-container>
  </template>
  <style lang="scss">
  </style>
  